import Mousetrap from 'mousetrap';
import pausePlugin from './pausePlugin';

pausePlugin(Mousetrap);

export default Mousetrap;
